// this is an autogenerated file from DesignSystem/PatientInformation/Content/ExternalProfessionals/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_PatientInformation_Content_ExternalProfessionals($patient_id: uuid!) {
  vaxiom_professional_relationships(
    where: {
      patient: { _id: { _eq: $patient_id } }
      dtype: { _eq: "otherProfessionalRelationship" }
      past: { _eq: false }
    }
  ) {
    id
    other {
      id
      person {
        id
        first_name
        last_name
        profile_pic_url
        emails: contact_method_associations(
          where: { contact_method: { dtype: { _eq: "email" } } }
          limit: 1
        ) {
          id
          email {
            id
            address
          }
        }
        phones: contact_method_associations(
          where: { contact_method: { dtype: { _eq: "phone" } } }
          limit: 1
        ) {
          id
          phone {
            id
            number
          }
        }
      }
    }
  }
}

`